import React, { useEffect } from 'react'
import Contents from '../home/components/contents'
import { ContentEl, LessonEl } from './elements'
import Header from './components/header'
import Video from './components/video'
import Info from './components/info'
import { withStoreProvider } from '../../../../../../../Helpers/withStoreProvider'
import LessonStore from './stores/LessonStore'
import ComponentLoader from '../../../../../../../Components/Loading/ComponentLoader'
import { withRouter } from 'react-router-dom'
import CourseStore from '../../../../../Store/CourseStore'
import withStore from '../../../../../../../Components/Unstated/withStore'
import { getNextLesson } from './utils'
import AssignmentUploader from './components/assignment-uploader'

const Lesson = ({
  match: {
    params: { chapterId, courseURL, lessonId, livDemyID },
  },
  courseStore: {
    state: { id, chapters, enrollments, cover, name, teacher },
  },
}) => {
  const { loading, loadFailed, setConfig } = LessonStore.useContainer()

  useEffect(() => {
    setConfig({
      courseId: id,
      chapterId,
      courseURL,
      lessonId,
      livDemyID,
      registrationId: enrollments[0]?.id,
    })
  }, [chapterId, courseURL, enrollments, id, lessonId, livDemyID, setConfig])

  const nextLesson = getNextLesson(chapters, chapterId, lessonId) || {}

  const currentChapter = chapters.find((chapter) => chapter.id === chapterId)
  const currentLesson = currentChapter.lessons.find(
    (lesson) => lesson.id === lessonId,
  )
  const currentChapterIndex = chapters.findIndex(
    (chapter) => chapter.id === chapterId,
  )
  const currentLessonIndex = currentChapter.lessons.findIndex(
    (lesson) => lesson.id === lessonId,
  )

  return (
    <LessonEl key={`${chapterId}-${lessonId}`}>
      <ComponentLoader loading={loading} loadFailed={loadFailed}>
        <ContentEl>
          <Header chapters={chapters} />
          <AssignmentUploader />
          <Video
            nextVideo={`/${livDemyID}/course/${courseURL}/chapter/${nextLesson.chapter}/lesson/${nextLesson.lesson}`}
            course={{
              name,
              teacher: teacher.name,
              cover,
              currentChapter,
              currentLesson,
              currentChapterIndex: currentChapterIndex + 1,
              currentLessonIndex: currentLessonIndex + 1,
            }}
          />
          <Info chapter={currentChapter} lesson={currentLesson} />
        </ContentEl>
      </ComponentLoader>
      <Contents />
    </LessonEl>
  )
}

export default withStore([CourseStore])(
  withStoreProvider([LessonStore])(withRouter(Lesson)),
)
